export const HEADING_TITLE = "Integrations";
export const SECTIONS = {
  ACCOUNTING_INTEGRATION_SETTINGS: "Default Item Mapping",
  ACCOUNTING_SYNC: "Sync to Accounting Package",
  ACCOUNTING_INTEGRATION_DETAILS: "Accounting Integration Details",
  ACCOUNT_INTEGRATIONS: "Accounting Integrations",
  ACCOUNT_INTEGRATION_OPTIONS: "Accounting Behaviour",
};

// The five connection states the backend can send us. It works this value out
// on its own every time we read the company, so we never recalculate it here.
export const ACCOUNTING_CONNECTION_STATUS = {
  CONNECTED: "connected",
  SYNCING: "syncing",
  ERROR: "error",
  DISCONNECTED: "disconnected",
  NOT_CONNECTED: "not_connected",
};

export const ACCOUNTING_SYNCING_STATUS = {
  QUEUED: "queued",
  RUNNING: "running",
  COMPLETE: "complete",
  FAILED: "failed",
};

// One badge label per connection state, matched exactly one-to-one.
export const ACCOUNTING_CONNECTION_STATUS_LABELS = {
  [ACCOUNTING_CONNECTION_STATUS.CONNECTED]: "Connected",
  [ACCOUNTING_CONNECTION_STATUS.SYNCING]: "Syncing in progress",
  [ACCOUNTING_CONNECTION_STATUS.ERROR]: "Something went wrong",
  [ACCOUNTING_CONNECTION_STATUS.DISCONNECTED]: "Reconnect required",
  [ACCOUNTING_CONNECTION_STATUS.NOT_CONNECTED]: "Not connected",
};

// One badge label per connection state, matched exactly one-to-one.
export const ACCOUNTING_SYNCING_STATUS_LABELS = {
  [ACCOUNTING_SYNCING_STATUS.QUEUED]: "Syncing in progress",
  [ACCOUNTING_SYNCING_STATUS.RUNNING]: "Syncing in progress",
  [ACCOUNTING_SYNCING_STATUS.COMPLETE]:
    "Get the latest list of customers, suppliers and item codes from your accounting",
  [ACCOUNTING_SYNCING_STATUS.FAILED]: "Syncing failed",
};

// States where "Update Accounting Data" has something to pull against.
// "error" is included because a retry is exactly what fixes it. The other
// states (syncing, disconnected, not connected) leave the button switched off.
export const ACCOUNTING_UPDATE_ALLOWED_STATUSES = [
  ACCOUNTING_CONNECTION_STATUS.CONNECTED,
  ACCOUNTING_CONNECTION_STATUS.ERROR,
];

// How the last sync run went. This is separate from the connection state above
// — a sync can fail while the connection itself is perfectly healthy.
export const ACCOUNTING_SYNC_JOB_STATE = {
  IDLE: "idle",
  QUEUED: "queued",
  RUNNING: "running",
  COMPLETE: "complete",
  FAILED: "failed",
};

export const ACCOUNTING_SYNC_INTRO = "Automatically send newly created:";

export const ACCOUNTING_SYNC_LABELS = {
  ACCOUNTING_SYNC_QUOTES: "Quotes",
  ACCOUNTING_SYNC_SALES: "Sales Orders",
  ACCOUNTING_SYNC_INVOICES: "Invoices",
  ACCOUNTING_SYNC_PAYMENTS: "Payments",
  ACCOUNTING_SYNC_PARTIAL_INVOICES: "Partial Invoices",
  ACCOUNTING_SYNC_PURCHASE_ORDERS: "Purchase Orders",
  ACCOUNTING_SYNC_BILLS: "Bills",
};

export const ACCOUNTING_SYNC_ORDER = Object.keys(ACCOUNTING_SYNC_LABELS);

export const ACCOUNTING_BEHAVIOUR_LABELS = {
  ACCOUNTING_ENFORCE_CREDIT_LIMITS_AND_CREDIT_HOLDS: "Enforce credit limits and credit holds",
  ACCOUNTING_DELETE_ORIGINAL_ORDER_IN_ACCOUNTING_PACKAGE:
    "Delete original order/invoice when partial invoice generated",
  ACCOUNTING_DELETE_QUOTE_AFTER_CONVERSION: "Delete Quote when converted to Order",
  ACCOUNTING_USE_FACTORY_DESCRIPTIONS: "Use Factory product descriptions",
  ACCOUNTING_DONT_SEND_PRICING_TABLE_ATTRIBUTE_TO_ACCOUNTING_PACKAGE:
    "Do not send pricing table attribute names",
  ACCOUNTING_USE_REQUIRED_DATE_AS_INVOICE_DATE: "Use order’s “Required date” as invoice date",
};

export const ACCOUNTING_BEHAVIOUR_ORDER = [
  "ACCOUNTING_ENFORCE_CREDIT_LIMITS_AND_CREDIT_HOLDS",
  "ACCOUNTING_DELETE_ORIGINAL_ORDER_IN_ACCOUNTING_PACKAGE",
  "ACCOUNTING_DELETE_QUOTE_AFTER_CONVERSION",
  "ACCOUNTING_USE_FACTORY_DESCRIPTIONS",
  "ACCOUNTING_DONT_SEND_PRICING_TABLE_ATTRIBUTE_TO_ACCOUNTING_PACKAGE",
  "ACCOUNTING_DISPLAY_ACCOUNTING_PACKAGE_CODES",
  "ACCOUNTING_MAP_ITEMS_TO_JOBS",
  "ACCOUNTING_USE_REQUIRED_DATE_AS_INVOICE_DATE",
];
